import React, { FC, useContext } from 'react'
import { Container, Row, Col } from '@mch-group/uikit-components'
import { formatDate } from '@utils/date'
import { PageContext } from '@providers/PageContext'
import classNames from 'classnames'

const EMInterviewDetails: FC<IEMInterviewDetails> = ({
  emids_title,
  emids_start_date,
  emids_end_date,
  emids_place,
  emids_description,
  id
}) => {
  const { page: { siteLanguage } } = useContext(PageContext)
  return (
    <section
      className={classNames('em-interview-details', siteLanguage === 'zh_CN' ?
        'mb-7 mb-md-8' : 'mb-9 mb-md-12')}
      id={id}>
      <Container className='px-5 px-lg-8 px-md-7'>
        <Row gutter='g-5 g-md-6 g-xl-7' className='my-0 py-0'>
          <Col
            xs={{ span: 12, offset: 0 }}
            sm={{ span: 12, offset: 0 }}
            md={{ span: 10, offset: 1 }}
            lg={{ span: 8, offset: 2 }}
            xl={{ span: 6, offset: 3 }}
            className='my-0 py-0'
          >
            <p className='text-medium mb-7 mb-lg-8 ms-0'>{emids_description}</p>
          </Col>
          <Col
            xs={{ span: 12, offset: 0 }}
            sm={{ span: 12, offset: 0 }}
            md={{ span: 10, offset: 1 }}
            lg={{ span: 8, offset: 2 }}
            xl={{ span: 6, offset: 3 }}
            className='my-0 py-0'>
            <span className='text-medium d-block'><b>{emids_title}</b></span>
            {emids_start_date && emids_end_date &&
              <span className='text-medium d-block'>
                {formatDate(emids_start_date, 'DD/MM/YYYY hh:mm', 'MMMM D')} - {formatDate(emids_end_date, 'DD/MM/YYYY hh:mm', 'MMMM D, YYYY')}
              </span>
            }
            <span className='text-medium d-block'>{emids_place}</span>
          </Col>

          <Col className='d-lg-none d-xl-block mt-0' xl={1} />
        </Row>
      </Container>
    </section >
  )
}
interface IEMInterviewDetails {
  [key: string]: string
}

export default EMInterviewDetails